import { render, staticRenderFns } from "./FormDeleteBtn.vue?vue&type=template&id=47b16fcd"
import script from "./FormDeleteBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./FormDeleteBtn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports